{
  "name": "@cue/platform",
  "type": "module",
  "version": "1.68.0",
  "private": true,
  "scripts": {
    "build": "nuxt generate",
    "dev": "nuxt dev --port=3010",
    "postinstall": "nuxt prepare",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "test": "vitest run",
    "typecheck": "nuxt typecheck"
  },
  "dependencies": {
    "@cue/clue": "workspace:^",
    "@cue/widget": "workspace:^",
    "@pinia/colada": "^1.4.8",
    "@pinia/colada-nuxt": "^1.2.0",
    "@pinia/nuxt": "^1.0.3",
    "@sentry/nuxt": "^11.9.0",
    "@vueuse/core": "^15.0.0",
    "@vueuse/router": "^15.0.0",
    "date-fns": "^4.4.0",
    "date-fns-tz": "^3.2.0",
    "es-toolkit": "^1.53.0",
    "motion-v": "^2.8.0",
    "nuxt": "^4.6.3",
    "nuxt-echarts": "^1.1.0",
    "pinia": "^4.1.0",
    "pinia-plugin-persistedstate": "^4.7.1",
    "polyfill-intl-enumeration": "1.0.0",
    "pug": "^3.0.4",
    "vue": "^3.5.44",
    "write-excel-file": "^4.1.1"
  },
  "devDependencies": {
    "@cue/eslint-config": "workspace:^",
    "@nuxt/test-utils": "^4.3.4",
    "@nuxtjs/i18n": "10.6.0",
    "@vue/test-utils": "^2.5.1",
    "eslint": "^10.13.0",
    "happy-dom": "^21.0.4",
    "typescript": "^6.0.3",
    "vitest": "^5.0.5",
    "vue-tsc": "^3.3.13"
  }
}
